import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useActiveUser } from '../hooks/useActiveUser';
import { metaRepo } from '../services/db/meta';

export default function AnonymousBanner() {
  const { isAnonymous } = useActiveUser();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    metaRepo.isAnonBannerDismissed().then(setDismissed);
  }, []);

  if (!isAnonymous || dismissed) return null;

  return (
    <div
      role="status"
      className="safe-area-top border-b border-amber-200 bg-amber-50 px-4 pb-2 text-xs text-amber-900 dark:border-amber-700/40 dark:bg-amber-900/20 dark:text-amber-200"
    >
      <div className="mx-auto flex max-w-lg items-center gap-3 pt-2">
        <span aria-hidden="true">⚠️</span>
        <p className="flex-1 leading-snug">
          <strong>Your data is on this device only.</strong> If you reinstall or
          switch devices, it will be lost.{' '}
          <Link to="/login" className="font-semibold underline">
            Sign in to back up
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={() => {
            metaRepo.dismissAnonBanner().then(() => setDismissed(true));
          }}
          aria-label="Dismiss"
          className="rounded p-1 text-amber-700 hover:bg-amber-100 dark:text-amber-300 dark:hover:bg-amber-900/40"
        >
          ×
        </button>
      </div>
    </div>
  );
}
